import Divider from 'LuxKit/Divider'
import Group from 'components/utils/Group'
import BodyText from 'LuxKit/Typography/BodyText'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import CarHireImportantInformationList from './CarHireImportantInformationList'
import { TabOptions } from './CarHireInclusionsAndDetailsModal'
import List from 'components/Common/List'
import { mediaQueryUp } from 'components/utils/breakpoint'
import CarHireImportantInformationSkeleton from './CarHireImportantInformationSkeleton'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

// If this is an 'odd' child, it's not actually inbetween anything, don't show it
const DetailsDivider = styled(Divider)`
  &:nth-child(odd), &:last-child {
    display: none;
  }
`

const ColumnedList = styled(List)`
  padding: ${rem(16)} 0;

  ${mediaQueryUp.tablet} {
    &.columns {
      column-count: 2;
    }
  }
`

const ImportantInfoSection = styled(Group)`
  padding: ${rem(16)} 0;
`
interface Props {
  offer: App.CarHireOffer;
  activeTab: App.CarHireImportantInformationCategory;
  offerImportantInformation?: Array<App.CarHireImportantInformation>
  hasError: boolean;
  isFetching?: boolean;
}

const isParagraphDupplicated = (paragraph: string, paragraphsList: Array<string>): boolean => {
  return paragraphsList.some(item => paragraph.includes(item))
}

function CarHireImportantDetailsContent(props: Props) {
  const { offer, offerImportantInformation, activeTab, hasError, isFetching } = props
  const inclusions = offer.copy.inclusions
  const otherInclusions = (offerImportantInformation || []).filter(item => item.category === 'Inclusions' && isParagraphDupplicated(item.category, inclusions))
  const offerImportantInformationIncludesFuelPolicy = offerImportantInformation?.find((item) => item.title === 'Fuel Policy')

  return <div>

    {activeTab === TabOptions.INCLUSIONS && (
      <>
        { !isFetching &&
          <ColumnedList className={inclusions.length > 5 ? 'columns' : undefined}>
            {inclusions.map(inclusion =>
              <BodyText variant="medium" as="li" key={inclusion}>
                {inclusion}
              </BodyText>,
            )}
            <BodyText variant="medium" as="li">
              {offer.mileage.unlimited && 'Unlimited mileage'}
              {!offer.mileage.unlimited && `${offer.mileage.quantity}${offer.mileage.unit}/${offer.mileage.period} rental mileage limit`}
            </BodyText>
          </ColumnedList>
        }

        {isFetching &&
          <VerticalSpacer gap={12}>
            <Divider kind="primary" />
            <CarHireImportantInformationSkeleton />
          </VerticalSpacer>
        }

        { !isFetching && otherInclusions.length > 0 &&
          <>
            <DetailsDivider kind="primary" />
            <CarHireImportantInformationList
              offerImportantInformation={offerImportantInformation}
              hasError={hasError}
              displayCategory={TabOptions.INCLUSIONS}
            />
          </>
        }
      </>
    )}

    {activeTab === TabOptions.COVERAGE &&
      <CarHireImportantInformationList
        offerImportantInformation={offerImportantInformation}
        hasError={hasError}
        displayCategory={TabOptions.COVERAGE}
      />
    }

    {activeTab === TabOptions.DRIVER_AND_VEHICLE &&
      <>
        {offer.copy.fuelPolicy && !offerImportantInformationIncludesFuelPolicy && (
          <ImportantInfoSection direction="vertical" gap={16}>
            <BodyText variant="medium" weight="bold">Fuel Policy</BodyText>
            <BodyText variant="medium" as="li">{offer.copy.fuelPolicy}</BodyText>
          </ImportantInfoSection>
        )}

        <DetailsDivider kind="primary" />

        <CarHireImportantInformationList
          offerImportantInformation={offerImportantInformation}
          hasError={hasError}
          displayCategory={TabOptions.DRIVER_AND_VEHICLE}
        />
      </>
    }

    {activeTab === TabOptions.DEPOSIT_AND_PAYMENT &&
      <CarHireImportantInformationList
        offerImportantInformation={offerImportantInformation}
        hasError={hasError}
        displayCategory={TabOptions.DEPOSIT_AND_PAYMENT}
      />
    }

    {activeTab === TabOptions.TRAVEL_RESTRICTIONS &&
      <CarHireImportantInformationList
        offerImportantInformation={offerImportantInformation}
        hasError={hasError}
        displayCategory={TabOptions.TRAVEL_RESTRICTIONS}
      />
    }

    {activeTab === TabOptions.OTHER &&
      <CarHireImportantInformationList
        offerImportantInformation={offerImportantInformation}
        hasError={hasError}
        displayCategory={TabOptions.OTHER}
      />
    }
  </div>
}

export default CarHireImportantDetailsContent
